import themeDefault from '@src/assets/admin/theme-default.json';
import { CssSkinModel, ExhibitionCustomStyles } from '@store/customization/customization.interfaces';
import { cloneDeep } from 'lodash';
import { ActionTypes, Actions } from './colorizer.actions';
import { StyleTemplateModel } from './colorizer.interface';

export interface State {
  styleTemplateId: number;
  styleTemplates: StyleTemplateModel[];
  selectedStyleTemplateStyles: CssSkinModel;
}

export const initialState: State = {
  styleTemplateId: null,
  styleTemplates: null,
  selectedStyleTemplateStyles: {
    priority: null,
    css: null,
    variables: null
  }
};

export function reducer(state = initialState, action: Actions): State {
  const clonedInitialState: State = cloneDeep(initialState);

  switch (action.type) {
    case ActionTypes.SET_ALL_STYLES:
      return {
        ...state,
        styleTemplates: action.payload
      };

    case ActionTypes.SET_STYLE: {
      if (!action.payload) {
        return state;
      }

      const stylesVariables: ExhibitionCustomStyles = action.payload.variables;

      return {
        ...state,
        selectedStyleTemplateStyles: {
          ...action.payload,
          variables: { ...themeDefault, ...stylesVariables }
        }
      };
    }

    case ActionTypes.SET_STYLE_ID: {
      const styleID = action.payload;

      // dont trigger new state if the id is the same as previous one
      if (state.styleTemplateId === styleID) {
        return state;
      }

      return {
        ...state,
        styleTemplateId: styleID
      };
    }

    case ActionTypes.ADD_STYLE_TO_LIST: {
      const style = action.payload;

      return {
        ...state,
        styleTemplates: [...state.styleTemplates, style],
        styleTemplateId: style.id
      };
    }

    case ActionTypes.RESET_REDUCER: {
      return clonedInitialState;
    }

    default: {
      return state;
    }
  }
}

export const allStyleTemplates = (state: State) => state.styleTemplates;
export const getStyle = (state: State) => state.selectedStyleTemplateStyles;
export const getStyleId = (state: State) => state.styleTemplateId;
